<template>
  <div>
    <el-select
      multiple
      filterable
      size="large"
      v-model="selecteds"
      placeholder="Filtros"
      @change="$emit('change', $event)"
    >

      <el-option
        v-for="tag in tags"
        :value="tag._id"
        :label="tag.name"
        :key="tag._id"
      />

    </el-select>
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import Tag from './InputTag'

export default {
  name: 'tag-list',
  props: {
    checkeds: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  model: {
    prop: 'checkeds',
    event: 'change'
  },
  data () {
    return {
      selecteds: []
    }
  },
  components: {
    Tag
  },
  methods: {
    ...mapActions('tags', ['fetchAll'])
  },
  watch: {
    checkeds: function () {
      this.selecteds = this.checkeds
    }
  },
  computed: {
    tags: {
      get () {
        return this.$store.state.tags.all
      }
    }
  },
  mounted () {
    this.fetchAll()
    this.selecteds = []
  }
}
</script>

<style>

.el-select {
  width: 100%;
}

.el-select__tags-text {
  color: white !important;
  font-weight: bold;
}
.el-tag.el-tag--info {
  border-color: #101010;
}

</style>



// WEBPACK FOOTER //
// src/components/Trg/Tags/ListTags.vue